const publicBaseUrl = process.env.PUBLIC_URL || '';

const fallbackImages = {
  hero: `${publicBaseUrl}/images/hero/hero-main.jpg`,
  services: [
    `${publicBaseUrl}/images/services/service-01.jpg`,
    `${publicBaseUrl}/images/services/service-02.jpg`,
    `${publicBaseUrl}/images/services/service-03.jpg`,
    `${publicBaseUrl}/images/services/service-04.jpg`,
    `${publicBaseUrl}/images/services/service-05.jpg`,
    `${publicBaseUrl}/images/services/service-06.jpg`,
    `${publicBaseUrl}/images/services/service-07.jpg`,
    `${publicBaseUrl}/images/services/service-08.jpg`
  ],
  portfolio: [
    `${publicBaseUrl}/images/portfolio/project-01.jpg`,
    `${publicBaseUrl}/images/portfolio/project-02.jpg`,
    `${publicBaseUrl}/images/portfolio/project-03.jpg`,
    `${publicBaseUrl}/images/portfolio/project-04.jpg`,
    `${publicBaseUrl}/images/portfolio/project-05.jpg`,
    `${publicBaseUrl}/images/portfolio/project-06.jpg`,
    `${publicBaseUrl}/images/portfolio/project-07.jpg`,
    `${publicBaseUrl}/images/portfolio/project-08.jpg`
  ]
};

// Put your cloud image links here (Cloudinary, ImageKit, etc.).
// Keep empty strings to use local fallback files from /public/images.
const cloudImages = {
  hero: '',
  services: ['', '', '', '', '', '', '', ''],
  portfolio: ['', '', '', '', '', '', '', '']
};

const pickImage = (cloudUrl, fallbackUrl) =>
  cloudUrl && cloudUrl.trim().length > 0 ? cloudUrl : fallbackUrl;

export const siteImages = {
  hero: pickImage(cloudImages.hero, fallbackImages.hero),
  services: fallbackImages.services.map((fallbackUrl, index) =>
    pickImage(cloudImages.services[index], fallbackUrl)
  ),
  portfolio: fallbackImages.portfolio.map((fallbackUrl, index) =>
    pickImage(cloudImages.portfolio[index], fallbackUrl)
  )
};

